import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-RejectShape",
  "use": "svg-icon-RejectShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-RejectShape\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12zm0-2a4 4 0 0 0 3.408-6.095l-5.503 5.503C6.515 11.784 7.232 12 8 12zM4.517 9.968l5.451-5.451a4 4 0 0 0-5.451 5.451z\" fill=\"#F33\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol